export class BudgetAllocationLevelDateSettings {
  id?: string;
  settingsId: string;
  level: number;
  dueDate = '';
}
